<div class="container-fluid">
	<div class="row d-md-flex d-none">
	    <div class="col-md-6">
	        <div class="card p-3 mt-3 card-votos mapa-puntos card-anticipados">
	            <div class="row justify-content-center">
	                <div class="col-12 text-center">
	                    <i class="fas fa-envelope icon-style-anti"></i>
	                    <h4 class="subtitulo-seccion py-3 text-center mb-0">Voto Anticipado</h4>
	                </div>
	            </div>
	            <div class="row justify-content-center">
	                <div class="col-6 col-xl-4 dis-flex">
	                    <button [routerLink]="['/'+ruta_anticipados]"
	                        class="btn btn-sm btn-rosaFuerte texto cursorPointer my-3 px-4 py-1">
	                        Ver Resultados
	                    </button>
	                </div>
	            </div>
	        </div>
	    </div>

	    <div class="col-md-6">
	        <div class="card p-3 mt-3 card-votos mapa-puntos card-preventivos">
	            <div class="row justify-content-center">
	                <div class="col-12 col-xl-10 text-center">
	                    <img height="60" *ngIf="!themeService.isDarkTheme()" src="./assets/img/generales/ic_votos_preventivos.png" />
	                    <img height="60" *ngIf="themeService.isDarkTheme()" src="./assets/img/generales/ic_votos_preventivos_blanco.png" />
	                    <h4 class="subtitulo-seccion py-3 text-center mb-0">Voto en Prisión Preventiva</h4>
	                </div>
	            </div>
	            <div class="row justify-content-center">
	                <div class="col-6 col-xl-4 dis-flex">
	                    <button [routerLink]="['/'+ruta_preventivos]"
	                        class="btn btn-sm btn-rosaFuerte texto cursorPointer my-3 px-4 py-1">
	                        Ver Resultados
	                    </button>
	                </div>
	            </div>
	        </div>
	    </div>
	</div>

	<div class="row d-flex d-md-none">
	    <div class="col-12">
	        <div class="card p-3 mt-3 card-votos mapa-puntos card-anticipados">
	            <div class="row justify-content-center">
	                <div class="col-12 text-center">
	                    <i class="fas fa-envelope icon-style"></i>
	                    <h4 class="subtitulo-seccion py-3 text-center mb-0 ">Voto Anticipado</h4>
	                </div>
	            </div>
	            <div class="row justify-content-center">
	                <div class="col-6 col-xl-4 dis-flex">
	                    <button [routerLink]="['/'+ruta_anticipados]"
	                        class="btn btn-sm btn-rosaFuerte texto cursorPointer my-3 px-4 py-1">
	                        Ver Resultados
	                    </button>
	                </div>
	            </div>
	        </div>
	    </div>

	    <div class="col-12">
	        <div class="card p-3 mt-3 card-votos mapa-puntos card-preventivos">
	            <div class="row justify-content-center">
	                <div class="col-12 col-xl-8 text-center">
	                    <img height="60" *ngIf="!themeService.isDarkTheme()" src="./assets/img/generales/ic_votos_preventivos.png" />
	                    <img height="60" *ngIf="themeService.isDarkTheme()" src="./assets/img/generales/ic_votos_preventivos_blanco.png" />
	                    <h4 class="subtitulo-seccion py-3 text-center mb-0">Voto en Prisión Preventiva</h4>
	                </div>
	            </div>
	            <div class="row justify-content-center">
	                <div class="col-6 col-xl-4 dis-flex">
	                    <button [routerLink]="['/'+ruta_preventivos]"
	                        class="btn btn-sm btn-rosaFuerte texto cursorPointer my-3 px-4 py-1">
	                        Ver Resultados
	                    </button>
	                </div>
	            </div>
	        </div>
	    </div>
	</div>
</div>